import { render, staticRenderFns } from "./aprovados.vue?vue&type=template&id=c8b147ec&scoped=true"
import script from "./aprovados.vue?vue&type=script&lang=js"
export * from "./aprovados.vue?vue&type=script&lang=js"
import style0 from "./aprovados.vue?vue&type=style&index=0&id=c8b147ec&prod&scoped=true&lang=css"
import style1 from "./aprovados.vue?vue&type=style&index=1&id=c8b147ec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8b147ec",
  null
  
)

export default component.exports